/* =============================================================
   CAGE PUNCH — theme.js
   Drawers, AJAX cart, product form (variants + selling plans),
   marquees, scroll reveals, accordions, sticky ATC.
   Bindings are idempotent (data-bound guards) and re-applied on
   shopify:section:load so the theme editor preview stays live.
   ============================================================= */
(function () {
  'use strict';

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- money ---------- */
  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var format = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var withDecimals = parts.join('.');
    var euro = value.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return format
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, parts[0].replace(/,/g, '.'))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, euro)
      .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/, withDecimals.replace(/,/g, "'"))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0])
      .replace(/\{\{\s*amount\s*\}\}/, withDecimals)
      .replace(/<[^>]*>/g, '');
  }

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function bindOnce(el, key) {
    if (!el || el.dataset['bound' + key]) return false;
    el.dataset['bound' + key] = '1';
    return true;
  }

  /* ---------- toast ---------- */
  var toastTimer;
  function toast(msg) {
    var el = $('[data-toast]');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('is-shown');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-shown'); }, 2600);
  }

  /* ---------- drawers (menu + cart) ---------- */
  var openDrawer = null;
  var lastFocus = null;

  function backdrop() { return $('[data-backdrop]'); }

  function trapFocus(e) {
    if (e.key !== 'Tab' || !openDrawer) return;
    var focusables = $$('button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])', openDrawer)
      .filter(function (el) { return el.offsetParent !== null; });
    if (!focusables.length) return;
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    else if (!openDrawer.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
  }
  document.addEventListener('keydown', trapFocus);

  function setDrawer(el, open) {
    if (!el) return;
    var bd = backdrop();
    var menuToggle = $('[data-menu-open]');
    var isMenu = el.hasAttribute('data-menu-drawer');
    if (open) {
      lastFocus = document.activeElement;
      if (openDrawer && openDrawer !== el) openDrawer.classList.remove('is-open');
      openDrawer = el;
      el.classList.add('is-open');
      el.removeAttribute('aria-hidden');
      if (bd) { bd.hidden = false; requestAnimationFrame(function () { bd.classList.add('is-open'); }); }
      document.body.classList.add('drawer-open');
      if (isMenu && menuToggle) menuToggle.setAttribute('aria-expanded', 'true');
      var focusable = el.querySelector('button, a[href], input, select');
      if (focusable) focusable.focus();
    } else {
      el.classList.remove('is-open');
      el.setAttribute('aria-hidden', 'true');
      if (openDrawer === el) openDrawer = null;
      if (bd) {
        bd.classList.remove('is-open');
        setTimeout(function () { if (!openDrawer) bd.hidden = true; }, 320);
      }
      document.body.classList.remove('drawer-open');
      if (isMenu && menuToggle) menuToggle.setAttribute('aria-expanded', 'false');
      if (lastFocus) { lastFocus.focus(); lastFocus = null; }
    }
  }

  function bindDrawers() {
    $$('[data-menu-open]').forEach(function (btn) {
      if (!bindOnce(btn, 'Menu')) return;
      btn.addEventListener('click', function () { setDrawer($('[data-menu-drawer]'), true); });
    });
    $$('[data-menu-close]').forEach(function (btn) {
      if (!bindOnce(btn, 'MenuC')) return;
      btn.addEventListener('click', function () { setDrawer($('[data-menu-drawer]'), false); });
    });
    $$('[data-cart-open]').forEach(function (btn) {
      if (!bindOnce(btn, 'Cart')) return;
      btn.addEventListener('click', function (e) {
        var drawer = $('[data-cart-drawer]');
        if (!drawer) return; // fall through to /cart link
        e.preventDefault();
        setDrawer(drawer, true);
      });
    });
    var bd = backdrop();
    if (bd && bindOnce(bd, 'Bd')) {
      bd.addEventListener('click', function () { setDrawer(openDrawer, false); });
    }
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openDrawer) setDrawer(openDrawer, false);
  });

  document.addEventListener('click', function (e) {
    var closeBtn = e.target.closest('[data-cart-close]');
    if (closeBtn) setDrawer($('[data-cart-drawer]'), false);
  });

  /* ---------- wholesale application modal ---------- */
  function closeWholesaleDialog(dialog, immediate, skipFocusRestore) {
    if (!dialog || !dialog.hasAttribute('open') || dialog.classList.contains('is-closing')) return;

    dialog._wholesaleSkipFocusRestore = Boolean(skipFocusRestore);

    var finish = function () {
      clearTimeout(dialog._wholesaleCloseTimer);
      dialog.classList.remove('is-closing');
      if (typeof dialog.close === 'function') dialog.close();
      else {
        dialog.removeAttribute('open');
        dialog.dispatchEvent(new Event('close'));
      }
    };

    if (immediate || REDUCED) {
      finish();
      return;
    }

    dialog.classList.add('is-closing');
    dialog._wholesaleCloseTimer = setTimeout(finish, 180);
  }

  function openWholesaleDialog(dialog, trigger) {
    if (!dialog || dialog.hasAttribute('open')) return;

    var section = dialog.closest('[data-wholesale-section]');
    var localTrigger = section && section.querySelector('[data-wholesale-open]');
    dialog._wholesaleTrigger = trigger || localTrigger;
    dialog.classList.remove('is-closing');

    if (typeof dialog.showModal === 'function') dialog.showModal();
    else {
      dialog.classList.add('is-fallback');
      dialog.setAttribute('open', '');
    }

    document.body.classList.add('modal-open');

    /* Shopify Forms can initialize while the dialog is closed. Give its
       responsive embed a fresh viewport signal once it is visible. */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        window.dispatchEvent(new Event('resize'));
      });
    });
  }

  function openWholesaleDeepLink(trigger) {
    if (window.location.hash !== '#wholesale-application') return;
    var section = document.getElementById('wholesale-application');
    if (!section) return;
    var dialog = section.querySelector('[data-wholesale-dialog]');
    if (!dialog) return;
    dialog._wholesaleOpenedByHash = true;
    openWholesaleDialog(dialog, trigger);
  }

  function syncWholesaleDeepLink() {
    var section = document.getElementById('wholesale-application');
    var dialog = section && section.querySelector('[data-wholesale-dialog]');
    if (window.location.hash === '#wholesale-application') {
      openWholesaleDeepLink();
    } else if (dialog && dialog._wholesaleOpenedByHash && dialog.hasAttribute('open')) {
      closeWholesaleDialog(dialog, false, true);
    }
  }

  function bindWholesaleDialogs() {
    $$('[data-wholesale-dialog]').forEach(function (dialog) {
      if (!bindOnce(dialog, 'WholesaleDialog')) return;

      var section = dialog.closest('[data-wholesale-section]');
      var trigger = section && section.querySelector('[data-wholesale-open]');
      var closeButton = dialog.querySelector('[data-wholesale-close]');

      if (trigger) {
        trigger.addEventListener('click', function () {
          openWholesaleDialog(dialog, trigger);
        });
      }

      if (closeButton) {
        closeButton.addEventListener('click', function () {
          closeWholesaleDialog(dialog);
        });
      }

      dialog.addEventListener('click', function (e) {
        if (e.target === dialog) closeWholesaleDialog(dialog);
      });

      dialog.addEventListener('cancel', function (e) {
        e.preventDefault();
        closeWholesaleDialog(dialog);
      });

      dialog.addEventListener('close', function () {
        clearTimeout(dialog._wholesaleCloseTimer);
        dialog.classList.remove('is-closing', 'is-fallback');
        document.body.classList.remove('modal-open');
        if (dialog._wholesaleOpenedByHash && window.location.hash === '#wholesale-application') {
          window.history.replaceState(null, '', window.location.pathname + window.location.search);
        }
        dialog._wholesaleOpenedByHash = false;
        if (!dialog._wholesaleSkipFocusRestore && dialog._wholesaleTrigger) {
          dialog._wholesaleTrigger.focus();
        }
        dialog._wholesaleSkipFocusRestore = false;
        dialog._wholesaleTrigger = null;
      });
    });

    $$('[data-wholesale-link]').forEach(function (link) {
      if (!bindOnce(link, 'WholesaleLink')) return;
      link.addEventListener('click', function (e) {
        if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

        var target = new URL(link.href, window.location.href);
        var isCurrentPage = target.origin === window.location.origin &&
          target.pathname === window.location.pathname;
        if (!isCurrentPage || target.hash !== '#wholesale-application') return;

        e.preventDefault();
        var currentUrl = new URL(window.location.href);
        currentUrl.hash = target.hash;
        window.history.replaceState(null, '', currentUrl.href);
        openWholesaleDeepLink(link);
      });
    });

    if (bindOnce(document.documentElement, 'WholesaleHash')) {
      window.addEventListener('hashchange', syncWholesaleDeepLink);
    }

    openWholesaleDeepLink();
  }

  /* ---------- cart AJAX ---------- */
  function routes() {
    var r = (window.theme && window.theme.routes) || {};
    return {
      add: r.cartAdd || '/cart/add',
      change: r.cartChange || '/cart/change',
      cart: r.cart || '/cart'
    };
  }

  function updateCartCount(count) {
    if (typeof count !== 'number') return;
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.dataset.count = count;
    });
    $$('[data-cart-open]').forEach(function (el) {
      el.setAttribute('aria-label', 'Cart (' + count + ' items)');
    });
  }

  function refreshCartSections() {
    var wanted = ['cart-drawer'];
    var mainCart = $('[data-main-cart]');
    /* JSON-template sections have dynamic ids on Shopify — read it off the DOM */
    if (mainCart) wanted.push(mainCart.dataset.sectionId || 'main-cart');
    return fetch(routes().cart + '?sections=' + wanted.join(','))
      .then(function (res) { return res.json(); })
      .then(function (sections) {
        Object.keys(sections).forEach(function (key) {
          if (!sections[key]) return;
          var doc = new DOMParser().parseFromString(sections[key], 'text/html');
          if (key === 'cart-drawer') {
            var target = $('[data-cart-drawer]');
            var next = doc.querySelector('[data-cart-drawer]');
            if (target && next) {
              target.innerHTML = next.innerHTML;
              target.className = next.className + (target.classList.contains('is-open') ? ' is-open' : '');
            }
          }
          else {
            var page = $('[data-main-cart]');
            var nextPage = doc.querySelector('[data-main-cart]');
            if (page && nextPage) page.innerHTML = nextPage.innerHTML;
          }
        });
        bindAll();
      })
      .catch(function () {});
  }

  function fetchCartState() {
    return fetch(routes().cart + '.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        return cart;
      });
  }

  function addToCart(formData, button) {
    if (button) { button.classList.add('is-loading'); button.setAttribute('aria-disabled', 'true'); }
    return fetch(routes().add + '.js', {
      method: 'POST',
      body: formData,
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (err) { throw err; });
        return res.json();
      })
      .then(function () {
        return Promise.all([fetchCartState(), refreshCartSections()]);
      })
      .then(function () {
        var drawer = $('[data-cart-drawer]');
        if (drawer) setDrawer(drawer, true);
        else toast('Added to the arsenal');
      })
      .catch(function (err) {
        toast((err && err.description) || 'Could not add — try again');
      })
      .then(function () {
        if (button) { button.classList.remove('is-loading'); button.removeAttribute('aria-disabled'); }
      });
  }

  function changeLine(line, quantity) {
    return fetch(routes().change + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (err) {
            toast((err && err.description) || 'Could not update the cart');
            return fetchCartState().then(refreshCartSections);
          });
        }
        return res.json().then(function (cart) {
          updateCartCount(cart.item_count);
          return refreshCartSections();
        });
      })
      .catch(function () {});
  }

  function bindCartControls() {
    $$('[data-line-qty]').forEach(function (wrap) {
      if (!bindOnce(wrap, 'LineQty')) return;
      var line = parseInt(wrap.dataset.lineQty, 10);
      var input = wrap.querySelector('input');
      wrap.addEventListener('click', function (e) {
        var minus = e.target.closest('[data-qty-minus]');
        var plus = e.target.closest('[data-qty-plus]');
        if (!minus && !plus) return;
        var qty = Math.max(0, parseInt(input.value || '1', 10) + (plus ? 1 : -1));
        input.value = qty;
        changeLine(line, qty);
      });
      input.addEventListener('change', function () {
        changeLine(line, Math.max(0, parseInt(input.value || '0', 10)));
      });
    });
    $$('[data-line-remove]').forEach(function (btn) {
      if (!bindOnce(btn, 'LineRm')) return;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        changeLine(parseInt(btn.dataset.lineRemove, 10), 0);
      });
    });
    /* quick add from product cards */
    $$('form[data-quick-add]').forEach(function (form) {
      if (!bindOnce(form, 'QuickAdd')) return;
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        addToCart(new FormData(form), form.querySelector('[type="submit"]'));
      });
    });
  }

  /* ---------- product form ---------- */
  function bindProductForms() {
    $$('[data-product-form]').forEach(function (root) {
      if (!bindOnce(root, 'Pf')) return;

      var dataEl = root.querySelector('[data-product-json]');
      if (!dataEl) return;
      var data;
      try { data = JSON.parse(dataEl.textContent); } catch (err) { return; }

      var form = root.querySelector('form');
      var idInput = root.querySelector('input[name="id"]');
      var priceEl = root.querySelector('[data-price]');
      var compareEl = root.querySelector('[data-compare-price]');
      var atcBtn = root.querySelector('[data-atc]');
      var atcPrice = root.querySelector('[data-atc-price]');
      var loadoutQuantity = root.querySelector('[data-loadout-quantity]');
      var loadoutItem = root.querySelector('[data-loadout-item]');
      var loadoutUnitPrice = root.querySelector('[data-loadout-unit-price]');
      var loadoutTotal = root.querySelector('[data-loadout-total]');
      var loadoutCadence = root.querySelector('[data-loadout-cadence]');
      var qtyInput = root.querySelector('[data-qty-input]');
      var stickyPrice = $('[data-sticky-price]');
      var stickyBtn = $('[data-sticky-atc] [data-atc-proxy]');

      function currentVariant() {
        var id = parseInt(idInput.value, 10);
        return data.variants.filter(function (v) { return v.id === id; })[0] || data.variants[0];
      }

      function rechargePlanId() {
        var widget = root.querySelector('recharge-subscription-widget');
        if (!widget || !widget.shadowRoot) return undefined;

        var purchaseOption = widget.shadowRoot.querySelector('input[name="purchaseOption"]:checked');
        if (purchaseOption && purchaseOption.value === 'onetime') return null;

        var plans = widget.shadowRoot.querySelector('rc-selling-plans');
        var planInput = plans && plans.shadowRoot
          ? plans.shadowRoot.querySelector('input[name="rc_plan"]:checked')
          : null;
        if (planInput && planInput.value) return parseInt(planInput.value, 10);

        /* The purchase option can be selected before Recharge mounts its
           nested plan control. Use the variant's first allocation during that
           short window so the initial CTA never flashes the one-time price. */
        if (purchaseOption && purchaseOption.value !== 'onetime') {
          var variant = currentVariant();
          if (variant.allocations && variant.allocations.length) {
            return variant.allocations[0].plan_id;
          }
        }
        return undefined;
      }

      function currentPlanId() {
        /* Recharge keeps its controls in nested Shadow DOM. Read its selected
           plan first, then fall back to ordinary theme/app form fields. */
        var rechargeId = rechargePlanId();
        if (rechargeId !== undefined) return rechargeId;

        var checked = root.querySelector('input[name="selling_plan"]:checked');
        var field = checked || root.querySelector('[name="selling_plan"]');
        if (field && field.value) return parseInt(field.value, 10);
        return null;
      }

      function priceFor(variant, planId) {
        if (planId && variant.allocations) {
          var alloc = variant.allocations.filter(function (a) { return a.plan_id === planId; })[0];
          if (alloc) return { price: alloc.price, compare: alloc.compare_at_price || variant.price };
        }
        return { price: variant.price, compare: variant.compare_at_price };
      }

      function render() {
        var variant = currentVariant();
        var planId = currentPlanId();
        var pricing = priceFor(variant, planId);
        var quantity = qtyInput ? Math.max(1, parseInt(qtyInput.value || '1', 10) || 1) : 1;
        var total = pricing.price * quantity;

        if (priceEl) priceEl.textContent = formatMoney(pricing.price);
        if (compareEl) {
          if (pricing.compare && pricing.compare > pricing.price) {
            compareEl.textContent = formatMoney(pricing.compare);
            compareEl.hidden = false;
          } else {
            compareEl.hidden = true;
          }
        }
        /* per-row prices in the plan picker */
        $$('[data-plan-row]', root).forEach(function (row) {
          var rowPriceEl = row.querySelector('[data-plan-row-price]');
          if (!rowPriceEl) return;
          var radio = row.querySelector('input[name="selling_plan"]');
          var sel = row.querySelector('select[data-plan-select]');
          var rowPlan = null;
          if (sel && sel.value) rowPlan = parseInt(sel.value, 10);
          else if (radio && radio.value) rowPlan = parseInt(radio.value, 10);
          rowPriceEl.textContent = formatMoney(priceFor(variant, rowPlan).price);
        });

        var itemLabel = variant.title && variant.title !== 'Default Title'
          ? variant.title
          : data.productTitle;
        if (loadoutQuantity) loadoutQuantity.textContent = quantity;
        if (loadoutItem) loadoutItem.textContent = itemLabel;
        if (loadoutUnitPrice) loadoutUnitPrice.textContent = formatMoney(pricing.price);
        if (loadoutTotal) loadoutTotal.textContent = formatMoney(total);
        if (loadoutCadence) {
          loadoutCadence.textContent = planId ? 'every month' : 'today';
        }

        var monthlyLabel = atcBtn && atcBtn.dataset.labelMonthly || 'Add Monthly Loadout';
        var oneTimeLabel = atcBtn && atcBtn.dataset.labelOnetime || 'Add to Cart';
        var purchaseLabel = planId ? monthlyLabel : oneTimeLabel;
        var label = variant.available
          ? purchaseLabel + ' — ' + formatMoney(total)
          : (atcBtn && atcBtn.dataset.labelSoldout) || 'Sold Out';
        if (atcPrice) {
          atcPrice.textContent = label;
        } else if (atcBtn) {
          atcBtn.textContent = label;
        }
        if (atcBtn) {
          atcBtn.disabled = !variant.available;
        }
        if (stickyPrice) stickyPrice.textContent = formatMoney(total);
        if (stickyBtn) {
          stickyBtn.textContent = planId ? monthlyLabel : oneTimeLabel;
          stickyBtn.disabled = !variant.available;
        }
      }

      /* variant option tiles */
      function syncTiles(variant) {
        $$('[data-option-tile]', root).forEach(function (t) {
          var on = variant.options[parseInt(t.dataset.optionIndex, 10) - 1] === t.dataset.value;
          t.classList.toggle('active', on);
          t.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      }
      $$('[data-option-tile]', root).forEach(function (tile) {
        tile.addEventListener('click', function () {
          if (tile.classList.contains('soldout')) return;
          var index = parseInt(tile.dataset.optionIndex, 10);
          var selected = [];
          for (var i = 1; i <= 3; i++) {
            var activeTile = root.querySelector('[data-option-tile][data-option-index="' + i + '"].active');
            selected.push(i === index ? tile.dataset.value : (activeTile ? activeTile.dataset.value : null));
          }
          var match = data.variants.filter(function (v) {
            return selected.every(function (val, idx) { return val === null || v.options[idx] === val; });
          })[0];
          if (!match) {
            /* sparse matrix: fall back to any variant with the clicked value, available first */
            var candidates = data.variants.filter(function (v) { return v.options[index - 1] === tile.dataset.value; });
            match = candidates.filter(function (v) { return v.available; })[0] || candidates[0];
          }
          if (!match) return;
          idInput.value = match.id;
          idInput.dispatchEvent(new Event('change', { bubbles: true }));
          syncTiles(match);
          render();
        });
      });

      /* App-block selling-plan controls can update independently of the
         theme's native plan rows. Keep the buy-box prices in sync. */
      root.addEventListener('change', function (e) {
        if (e.target.matches('[name="selling_plan"]')) render();
      });

      var rechargeRetryCount = 0;
      var rechargeRetryTimer;
      function scheduleRechargeRetry() {
        if (rechargeRetryCount >= 120) return;
        rechargeRetryCount += 1;
        clearTimeout(rechargeRetryTimer);
        rechargeRetryTimer = setTimeout(bindRechargeControls, 50);
      }

      function bindRechargeControls() {
        var widget = root.querySelector('recharge-subscription-widget');
        if (!widget || !widget.shadowRoot) {
          scheduleRechargeRetry();
          return;
        }

        if (bindOnce(widget, 'Recharge')) {
          widget.shadowRoot.addEventListener('change', function () {
            requestAnimationFrame(function () {
              bindRechargeControls();
              render();
            });
          });
          new MutationObserver(function () {
            bindRechargeControls();
          }).observe(widget.shadowRoot, { childList: true, subtree: true });
        }

        var plans = widget.shadowRoot.querySelector('rc-selling-plans');
        var hasSellingPlanAllocations = data.variants.some(function (variant) {
          return variant.allocations && variant.allocations.length > 0;
        });

        /* Recharge attaches this nested Shadow Root after its outer custom
           element is ready. Keep checking until the selected plan exists so
           the initial price is as accurate as later click-driven updates. */
        if (hasSellingPlanAllocations && (!plans || !plans.shadowRoot ||
          !plans.shadowRoot.querySelector('input[name="rc_plan"]:checked'))) {
          scheduleRechargeRetry();
          render();
          return;
        }

        rechargeRetryCount = 0;
        clearTimeout(rechargeRetryTimer);

        if (plans && plans.shadowRoot && bindOnce(plans, 'RechargePlans')) {
          var updateRechargePrice = function () {
            requestAnimationFrame(render);
          };
          plans.shadowRoot.addEventListener('change', updateRechargePrice);
          plans.shadowRoot.addEventListener('click', updateRechargePrice);
        }

        render();
      }
      bindRechargeControls();
      if (window.customElements && window.customElements.whenDefined) {
        window.customElements.whenDefined('recharge-subscription-widget').then(bindRechargeControls);
      }

      /* selling plan rows — radios are name="selling_plan" so native submits work */
      $$('[data-plan-row]', root).forEach(function (row) {
        row.addEventListener('click', function () {
          $$('[data-plan-row]', root).forEach(function (r) { r.classList.remove('active'); });
          row.classList.add('active');
          var radio = row.querySelector('input[type="radio"]');
          if (radio) radio.checked = true;
          render();
        });
        var sel = row.querySelector('select[data-plan-select]');
        if (sel) sel.addEventListener('change', function () {
          var radio = row.querySelector('input[type="radio"]');
          if (radio) radio.value = sel.value;
          render();
        });
      });

      /* qty stepper */
      $$('[data-qty-minus], [data-qty-plus]', root).forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (!qtyInput) return;
          var val = parseInt(qtyInput.value || '1', 10);
          qtyInput.value = Math.max(1, val + (btn.hasAttribute('data-qty-plus') ? 1 : -1));
          render();
        });
      });
      if (qtyInput) {
        qtyInput.addEventListener('input', render);
        qtyInput.addEventListener('change', function () {
          qtyInput.value = Math.max(1, parseInt(qtyInput.value || '1', 10) || 1);
          render();
        });
      }

      /* submit */
      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          addToCart(new FormData(form), atcBtn);
        });
      }

      /* sticky mobile bar proxies the real button */
      if (stickyBtn && bindOnce(stickyBtn, 'Sticky')) {
        stickyBtn.addEventListener('click', function () {
          if (form) form.dispatchEvent(new Event('submit', { cancelable: true }));
        });
      }
      var sticky = $('[data-sticky-atc]');
      if (sticky && atcBtn && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          sticky.classList.toggle('is-shown', !entries[0].isIntersecting);
        }, { rootMargin: '-80px 0px 0px 0px' }).observe(atcBtn);
      }

      render();
    });
  }

  /* ---------- gallery ---------- */
  function bindGalleries() {
    $$('[data-gallery]').forEach(function (gallery) {
      if (!bindOnce(gallery, 'Gal')) return;
      var main = gallery.querySelector('[data-main-image]');
      gallery.addEventListener('click', function (e) {
        var thumb = e.target.closest('[data-thumb]');
        if (!thumb || !main) return;
        $$('[data-thumb]', gallery).forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
        var img = thumb.querySelector('img');
        if (img) {
          main.src = thumb.dataset.src || img.src;
          main.srcset = thumb.dataset.srcset || '';
          main.alt = img.alt || '';
        }
      });
    });
  }

  /* ---------- accordions ---------- */
  function bindAccordions() {
    $$('[data-acc]').forEach(function (acc) {
      if (!bindOnce(acc, 'Acc')) return;
      var head = acc.querySelector('[data-acc-head]');
      if (!head) return;
      head.setAttribute('aria-expanded', acc.classList.contains('is-open') ? 'true' : 'false');
      head.addEventListener('click', function () {
        var open = acc.classList.toggle('is-open');
        head.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* ---------- marquee ---------- */
  function bindMarquees() {
    $$('[data-marquee]').forEach(function (marquee) {
      if (!bindOnce(marquee, 'Mq')) return;
      var track = marquee.querySelector('.marquee-track');
      var seg = marquee.querySelector('.marquee-seg');
      if (!track || !seg) return;
      /* fill one viewport width, then double the set for a seamless -50% loop */
      var safety = 0;
      while (track.scrollWidth < marquee.offsetWidth && safety < 20) {
        track.appendChild(seg.cloneNode(true)).setAttribute('aria-hidden', 'true');
        safety++;
      }
      $$('.marquee-seg', track).forEach(function (s) {
        var clone = s.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      });
    });
  }

  /* ---------- scroll reveals + hero entrance ---------- */
  function bindReveals() {
    if (REDUCED || !('IntersectionObserver' in window)) {
      $$('[data-reveal], [data-reveal-group]').forEach(function (el) { el.classList.add('is-in'); });
      $$('.hero').forEach(function (h) { h.classList.add('enter'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    $$('[data-reveal]:not(.is-in), [data-reveal-group]:not(.is-in)').forEach(function (el) { io.observe(el); });

    $$('.hero').forEach(function (h) {
      if (!bindOnce(h, 'Hero')) return;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { h.classList.add('enter'); });
      });
    });
  }

  /* ---------- sort select ---------- */
  function bindSort() {
    $$('[data-sort-select]').forEach(function (sel) {
      if (!bindOnce(sel, 'Sort')) return;
      sel.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sel.value);
        window.location.href = url.toString();
      });
    });
  }

  /* ---------- boot ---------- */
  function bindAll() {
    bindDrawers();
    bindCartControls();
    bindProductForms();
    bindGalleries();
    bindAccordions();
    bindMarquees();
    bindReveals();
    bindSort();
    bindWholesaleDialogs();
  }

  /* reveal-hiding CSS is gated on this class so a failed script load
     degrades to fully visible content */
  document.documentElement.classList.add('reveals');

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAll);
  } else {
    bindAll();
  }

  /* theme editor support */
  document.addEventListener('shopify:section:load', bindAll);
})();
